import axios from 'axios';
import config from '../config';
import { requestHeaders } from '../helpers';

export const feedbackService = {
  sendFeedback,
};

function sendFeedback(data) {
  return axios.post(`${config.URL_BASE}/user-feedback`, data, requestHeaders())
}